module.exports = __webpack_public_path__ + "img/user-icon.edcd7783.svg";